export const randomString = (length: number): string => {
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$^&*()';
  return [...Array(length)]
    .map(() => characters[Math.floor(Math.random() * characters.length)])
    .join('');
};

export const singularOrPluralTranslation = (
  num: number,
  singularTranslation: string,
  pluralTranslation: string,
) => {
  if (Number(num) === 1) {
    return singularTranslation;
  } else {
    return pluralTranslation;
  }
};

export const sanitizeText = (text: string) =>
  text.replace(/</g, '&lt;').replace(/>/g, '&gt;');

const BLOCK_TAG_PATTERN = /<(p|div|h[1-6]|ul|ol|li|blockquote|pre)\b/gi;

export const isPhrasingSafeHtml = (html: string): boolean =>
  (html.match(BLOCK_TAG_PATTERN) || []).length <= 1;

export const toPhrasingHtml = (html: string): string =>
  html
    .replace(/<\/(p|div|h[1-6]|li|blockquote|pre)\s*>\s*/gi, '<br>')
    .replace(/<(p|div|h[1-6]|li|blockquote|pre|ul|ol)\b[^>]*>/gi, '')
    .replace(/<\/(ul|ol)\s*>/gi, '')
    .replace(/(<br\s*\/?>)+$/i, '')
    .trim();
